<nz-affix>
  <nz-page-header>
    <nz-page-header-title>Версии приложений</nz-page-header-title>
  </nz-page-header>
</nz-affix>

<div nz-row [nzGutter]="16">
  <div nz-col nzSpan="8">
    <form nz-form nzLayout="vertical">
      <nz-form-item>
        <nz-form-label>Приложение</nz-form-label>
        <nz-form-control>
          <nz-select [(ngModel)]="appName" name="appName" (ngModelChange)="load()" style="width: 100%">
            @for (name of appNames; track name) {
              <nz-option [nzValue]="name" [nzLabel]="name"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Мажорная версия приложения</nz-form-label>
        <nz-form-control>
          <!-- Бандл получают только устройства с этой мажорной версией: web-код собран
               под конкретную нативную оболочку. -->
          <input nz-input type="number" min="1" [(ngModel)]="form.major" name="major" placeholder="3">
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Версия бандла</nz-form-label>
        <nz-form-control>
          <!-- Должна быть выше нативной версии, иначе обновление не предложится. -->
          <input nz-input [(ngModel)]="form.version" name="version" placeholder="3.0.1">
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Архив бандла (zip)</nz-form-label>
        <nz-form-control>
          <nz-upload [nzAction]="uploadUrl" nzName="file" nzAccept=".zip" [nzMultiple]="false"
                     (nzChange)="onUploadChange($event)">
            <button nz-button type="button">
              <span nz-icon nzType="upload"></span>
              Выбрать zip
            </button>
          </nz-upload>
          @if (form.hash) {
            <div style="margin-top: 8px; word-break: break-all; color: #888; font-size: 12px;">{{ form.hash }}</div>
          }
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Обязательное обновление из стора</nz-form-label>
        <nz-form-control>
          <!-- Устройства с мажорной версией НИЖЕ этой получат экран обязательного обновления. -->
          <nz-switch [(ngModel)]="form.updateRequired" name="updateRequired"></nz-switch>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Описание (ru)</nz-form-label>
        <nz-form-control>
          <input nz-input [(ngModel)]="form.ru" name="ru" placeholder="Улучшения и исправления">
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Описание (kk)</nz-form-label>
        <nz-form-control>
          <input nz-input [(ngModel)]="form.kk" name="kk" placeholder="Жақсартулар">
        </nz-form-control>
      </nz-form-item>

      <button nz-button nzType="primary" type="button" (click)="save()">Опубликовать</button>
    </form>
  </div>

  <div nz-col nzSpan="16">
    <nz-table #table [nzData]="versions" [nzLoading]="loading" [nzShowPagination]="false" nzSize="small">
      <thead>
      <tr>
        <th nzWidth="90px">Мажор</th>
        <th nzWidth="110px">Версия</th>
        <th>Хэш</th>
        <th nzWidth="120px">Обязательное</th>
        <th nzWidth="140px"></th>
      </tr>
      </thead>
      <tbody>
        @for (row of table.data; track row.major) {
          <tr>
            <td>{{ row.major }}</td>
            <td>{{ row.version }}</td>
            <td style="word-break: break-all; font-size: 12px;">{{ row.hash }}</td>
            <td>
              @if (row.updateRequired) {
                <nz-tag nzColor="red">да</nz-tag>
              } @else {
                <nz-tag>нет</nz-tag>
              }
            </td>
            <td>
              <button nz-button nzSize="small" type="button" (click)="edit(row)">Изменить</button>
              <button nz-button nzSize="small" nzDanger type="button" style="margin-left: 8px;"
                      nz-popconfirm nzPopconfirmTitle="Удалить версию?" (nzOnConfirm)="remove(row.major)">
                Удалить
              </button>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
</div>
